import { Box, Button, HStack, Text } from "@chakra-ui/react";
import SwitchFilter from "modules/filters/components/SwitchFilter";
import { useUserRegions } from "modules/regions/hooks/useUserRegions";
import { useTranslation } from "react-i18next";

interface RegionsFilterProps {
  selectedRegions: string[];
  setSelectedRegions: (regions: string[]) => void;
}

const RegionsFilter = ({
  selectedRegions,
  setSelectedRegions,
}: RegionsFilterProps) => {
  const { t } = useTranslation();
  const regions = useUserRegions(true);

  return (
    <Box position="relative" marginTop="40px">
      <HStack>
        <Text textStyle="subtitle">{t("filters.filter")}</Text>

        <Button
          onClick={() => setSelectedRegions([])}
          alignSelf="end"
          color="monza"
          fontSize="10px"
          fontWeight="700"
          textDecoration="underline"
          size="xs"
          colorScheme="white"
        >
          {t("filters.reset_filters")}
        </Button>
      </HStack>

      <Box marginTop="10px">
        <SwitchFilter
          column={{
            id: "regions",
            filterValue: selectedRegions,
            setFilter: setSelectedRegions,
          }}
          preFilteredValues={regions}
        />
      </Box>
    </Box>
  );
};

export default RegionsFilter;
